//
// #####################################################################################################################
//
export const isValidDate = (date) => {
	return new Date(date) !== "Invalid Date" && !isNaN(new Date(date));
};
//
// #####################################################################################################################
//
export const padTo2Digits = (num) => {
	return num.toString().padStart(2, "0");
};
//
// #####################################################################################################################
//
export const formatDate = (date = new Date(), format = "YMD") => {

	format = format.toUpperCase();
	let _dateFormatted = "";
	switch (format) {
		case "YMD":
			_dateFormatted = [
				date.getFullYear(),
				padTo2Digits(date.getUTCMonth() + 1),
				padTo2Digits(date.getUTCDate()),
			].join("/");
			break;

		case "YMD-":
			_dateFormatted = [
				date.getFullYear(),
				padTo2Digits(date.getUTCMonth() + 1),
				padTo2Digits(date.getUTCDate()),
			].join("-");
			break;

		case "DMY":
			_dateFormatted = [
				padTo2Digits(date.getUTCDate()),
				padTo2Digits(date.getUTCMonth() + 1),
				date.getFullYear(),
			].join("/");
			break;

		case "DMY HM":
			_dateFormatted = [
				padTo2Digits(date.getUTCDate()),
				padTo2Digits(date.getUTCMonth() + 1),
				date.getFullYear(),
			].join("/") + " " + date.getUTCHours().toString().padStart(2, "0") + ":" + date.getUTCMinutes().toString().padStart(2, "0");
			break;

		default:
	}
	return _dateFormatted;
};
//
// #####################################################################################################################
//
export const isPositiveInteger = (str) => {
	if (typeof str !== "string") {
		return false;
	}

	const num = Number(str);

	if (Number.isInteger(num) && num > 0) {
		return true;
	}

	return false;
};
//
// #####################################################################################################################
//
export const onlyLettersAndSpaces = (str) => {
	return /^[A-Za-z\s]*$/.test(str);
};
//
// #####################################################################################################################
//
export const getAge = (dateString) => {
	let today = new Date();
	let birthDate = new Date(dateString);
	let age = today.getFullYear() - birthDate.getFullYear();
	let m = today.getMonth() - birthDate.getMonth();
	if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
		age--;
	}
	return age;
};
//
// #####################################################################################################################
//
export const isValidEmail = (email) => {
	if (
		String(email)
			.toLowerCase()
			.match(
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			) !== null
	) {
		return true;
	} else {
		return false;
	}
};
//
// #####################################################################################################################
//
export const isEmptyObject = (object) => {
	return Object.keys(object).length === 0;
};
//
// #####################################################################################################################
//
export const isNumeric = (str) => {
	if (typeof str != "string") return false // we only process strings!
	return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
		!isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}
//
// #####################################################################################################################
//
export const roundNumber = (par_number) => {
	if (isNaN(par_number)) {
		// si el valor recibido no es un numero
		return 0;
	}
	return Math.round((par_number + Number.EPSILON) * 100) / 100;
}
//
// #####################################################################################################################
//
export const camelToUnderscore = (par_string) => {
	let result = par_string.replace(/([A-Z])/g, " $1");
	return result.split(' ').join('_').toLowerCase();
}
//
// #############################################################################
// 
export const getUserData = () => {
	let user = JSON.parse(localStorage.getItem("user"));
	return user;
}
//
// #############################################################################
// 
export const extraerIds = (par_error_message) => {

	const pattern = /articulo \[(.*?)\].*area de origen \[(.*?)\]/;
	const match = par_error_message.match(pattern);
	if (match) {
		const articuloId = match[1];
		const areaOrigenId = match[2];
		return { articuloId, areaOrigenId };
	} else {
		return null; // Retorna null si no encuentra los IDs
	}
}
//
// #############################################################################
//
export const limpiaCodigo = (str) => {
	return String(str ?? "")
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.replace(/[^a-zA-Z0-9]/g, "");
}
//
// ################################################################################
//
export const formatMoney = (value, digits = 2) => {
	if (value == null) return "-";

	return new Intl.NumberFormat("es-AR", {
		minimumFractionDigits: digits,
		maximumFractionDigits: digits,
	}).format(value);
};
//
// #####################################################################################################################
//
export const formatEsferaCilindroAdicion = (num) => {
	const sign = num < 0 ? "-" : "";
	const abs = Math.abs(Number(num));
	const [entero, decimal] = abs.toFixed(2).split(".");
	return `${sign}${entero.padStart(2, "0")}.${decimal}`;
};
//
// ################################################################################
//
export const isTokenExpired = (parToken, parTokenExp) => {

	if (!parToken || !parTokenExp) {
		// si no hay token o no hay fecha de expiracion, se considera que el token esta expirado
		return true;
	}

	try {
		return parTokenExp * 1000 < Date.now();
	} catch (error) {
		return true;
	}
};
//
// ################################################################################
//
export const limpiaLocalStorage = () => {
	localStorage.removeItem('token');
	localStorage.removeItem('token_exp');
	localStorage.removeItem('id_usuario');
	localStorage.removeItem("nombre_usuario");
	localStorage.removeItem('apellido_usuario');
};
//
// ################################################################################
//
export const generaCodigo = (parLongitud = 9) => {
	const _caracteres = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
	let _codigo = "";
	for (let i = 0; i < parLongitud; i++) {
		const _indice = Math.floor(Math.random() * _caracteres.length);
		_codigo += _caracteres[_indice];
	}
	return _codigo;
}